// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".periods-item[data-v-e63c296c]{gap:.5rem}.periods-item .period[data-v-e63c296c]{width:25%}@media(max-width: 991.98px){.cancel-policies-text[data-v-e63c296c]{text-align:center;display:block;margin:10px 0}.periods-item .period[data-v-e63c296c]{width:100%}}.select-language-icon[data-v-e63c296c]{margin-right:.5rem;margin-bottom:.5rem;cursor:pointer}", ""]);
// Exports
module.exports = exports;
